// Dependencies
import React from 'react';
import _ from 'lodash';
import Api from '../api'
import { Helpers, Defaults, Config } from '../utils';

// Types
import { Containers, Types } from '../types';
import ProductArea from './ProductArea';
import useEventBus from '../hooks/useEventBus';

const initialState: any = {
    loading: true,
    addingToCart: false,
    history: [],
    errors: {},
    product: {},
    ...Defaults
}

const App = () => {
    
    // NOTE: Handles data fetching only (both from internal and external sources)
    const [store, updateStore] = React.useState<any>(initialState);
    const {dispatch} = useEventBus();

    const setState = (key: string, value: any) => {
        if (!(key in initialState)) {
            throw Error(`Key ${key} is not valid state.`);
        }
        updateStore((prevStore: any) => ({ ...prevStore, [key]: value instanceof Function ? value(prevStore[key]) : value, }))
    }

    const handleProductAddToCart = async ({id, type, selected, quantity: {selected: quantity} }: any) => {
        if ( store.loading || store.addingToCart ) {
            return;
        }
        setState('addingToCart', true);
        setState('loading', true);
        // NOTE: Assign reccursion limit
        // TOOD: Validate/state canAddToCart
        let response;
        try {
            response = await Api.addProductToCart(id, {
                quantity,
                type,
                selected
            });
            if ( _.isEmpty(response?.errors) ) {
                dispatch('cartContentsUpdated', {...response})
            }
        } catch (e) {
            console.log(e);
        }
        
        setState('loading', false);
        setState('addingToCart', false);
    }

    const loadInternalData = async () => {

        const data = {
            product: {  // Try to get via API, split data to dynamic and static, include static in DOM
                id: Config.REACT_APP_PRODUCT_ID,
                type: Config.REACT_APP_PRODUCT_TYPE
            },           
            ...Config.REACT_APP_DATA
        }

        updateStore((prevState: any) => _.merge(Defaults, prevState, data));
    }

    const loadExternalData = async () => {
        setState('loading', true);

        // TODO: Check if productID is provied and is valid number before request
        if ( _.isEmpty( Config.REACT_APP_PRODUCT_ID ) ) {
            throw new Error(`No product has been provided.`)
        }

        try {
            const response = await Api.getProduct(Config.REACT_APP_PRODUCT_ID);

            if ( _.isEmpty(response?.errors) ) {
                updateStore((prevState: any) => _.merge(Defaults, prevState, response));
                setState('loading', false);
            }
        } catch (e) {
            console.log(e);
        }
        
    }
    React.useEffect(() => {
        loadInternalData();
        loadExternalData();
        return () => {}
    }, []);

    if ( _.isEmpty(store?.product) ) return null;

    // TODO: This will be actually the main App component handling data fetching
    return <ProductArea {...store} onAddToCart={handleProductAddToCart} />
    
}

export default App;
